module.exports = __webpack_public_path__ + "static/media/wechat.9ec1c428.svg";